<template>
    <div class="title">
        <div :class="['symbol', visible]"></div>
        <sequential-entrance :delay="delay" animation="wordIn">
            <span v-for="item in titleArr()" :key="item.id" class="word is-lato" :class="custom">{{item}}</span>
        </sequential-entrance>
    </div>
</template>

<script>
export default {
    name: 'Title',
    props: [ 'title', 'custom' ],
    data: function () {
        return {
            visible: '',
            length: 0,
            delay: 100
        }
    },
    methods: {
        titleArr: function () {
            let title = this.title.split('')
            this.length = title.length
            return title
        },
        setVisible: function () {
            this.visible = 'is-visible'
            return this.visible
        }
    },
    mounted: function () {
        let self = this
        setTimeout(function () {
            self.setVisible()
        }, this.delay * this.length + 1)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
.title {
    overflow: visible;
    width: 100%;
    text-align: center;
    white-space: nowrap;
    .symbol {
        width: 20px;
        height: 25px;
        margin: 0 auto 20px;
        background: url(../../assets/image/logo/box01.svg) no-repeat center;
        background-size: 100% auto;
        opacity: 0;
        transform: translateY(-15px);
        transition: opacity 1000ms, transform 1000ms;
        &.is-visible {
            opacity: 1;
            transform: translateY(0);
        }
    }
    .word {
        display: inline-block;
        font-size: 42px;
        line-height: 42px;
        font-weight: 700;
        color: #fff;
        margin-left: 44px;

        &:first-child {
            margin-left: 0;
        }
    }
    @include under-tablet {
        .symbol {
            width: 5.4vw;
            height: 8vw;
            margin-bottom: 2.8vw;
        }
        .word {
            font-size: 7vw;
            line-height: 7vw;
            margin-left: 6.4vw;
        }
    }
}
@keyframes fadeIn {
    0% {transform: translateX(20px); opacity: 0;}
    100% {transform: translateX(0); opacity: 1;}
}
.wordIn {
    position: relative;
    animation: fadeIn 1000ms;
}
@include desktop-small {
    .gn-title:nth-child(7) {
    display: block;
    }
    .gn-title:nth-child(8) {
        margin-top: 2vw;
        margin-left: 0;
    }
}
@include under-tablet {
    .gn-title:nth-child(7) {
    display: block;
    }
    .gn-title:nth-child(8) {
        margin-top: 2vw;
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Title.vue